var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTele2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 378,
    height: 208,
    viewBox: "0 0 378 208",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M365.38 208.09C372.333 208.09 377.97 202.453 377.97 195.5C377.97 188.547 372.333 182.91 365.38 182.91C358.427 182.91 352.79 188.547 352.79 195.5C352.79 202.453 358.427 208.09 365.38 208.09Z",
    fill: "#C8024C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.37 208.09C304.323 208.09 309.96 202.453 309.96 195.5C309.96 188.547 304.323 182.91 297.37 182.91C290.417 182.91 284.78 188.547 284.78 195.5C284.78 202.453 290.417 208.09 297.37 208.09Z",
    fill: "#BC00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.36 208.09C236.313 208.09 241.95 202.453 241.95 195.5C241.95 188.547 236.313 182.91 229.36 182.91C222.407 182.91 216.77 188.547 216.77 195.5C216.77 202.453 222.407 208.09 229.36 208.09Z",
    fill: "#0065FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.35 208.09C168.303 208.09 173.94 202.453 173.94 195.5C173.94 188.547 168.303 182.91 161.35 182.91C154.397 182.91 148.76 188.547 148.76 195.5C148.76 202.453 154.397 208.09 161.35 208.09Z",
    fill: "#00B2E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.34 208.09C100.293 208.09 105.93 202.453 105.93 195.5C105.93 188.547 100.293 182.91 93.34 182.91C86.3867 182.91 80.75 188.547 80.75 195.5C80.75 202.453 86.3867 208.09 93.34 208.09Z",
    fill: "#00C24F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.33 208.09C32.2833 208.09 37.92 202.453 37.92 195.5C37.92 188.547 32.2833 182.91 25.33 182.91C18.3767 182.91 12.74 188.547 12.74 195.5C12.74 202.453 18.3767 208.09 25.33 208.09Z",
    fill: "#F7C500"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M376.47 140.66V112.89L324.22 114.39L338 100C363.7 72.78 374.85 59 374.85 35.88C374.85 14.6 358.63 0 335.11 0C301.46 0 281.59 21.69 283.8 57.82L311.8 55.39C311.634 53.9061 311.567 52.4128 311.6 50.92C311.6 36.94 318.49 28.62 329.44 28.62C338.15 28.62 342.82 34.3 342.82 42.01C342.82 48.9 339.78 55.59 333.09 63.49C324.57 73.43 301.26 98.57 282.81 116V140.66H376.47ZM199.47 21.89L272.04 11.56V35.88L225.62 41.15V66.5L265.35 63.5V86.77L225.64 89V117.79L272.06 116.16V140.69H199.49L199.47 21.89ZM190.14 118.8L150 119.61V28.79L127.31 32V140.69H190.14V118.8ZM62.64 41.15L117.38 33.45V53.12L82.51 57.37V79.27L112.31 77V95.89L82.51 97.72V122L117.38 121.19V140.65H62.64V41.15ZM0 49.87L53.93 42.37V62L36.29 63.86V140.69H17.64V65.89L0 67.71V49.87Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 378,
    height: 208,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTele2);
export default __webpack_public_path__ + "static/media/tele2.23cb5d4b105e6a49dc727c9b2ffef783.svg";
export { ForwardRef as ReactComponent };